var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHevronIrcle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_756_5443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.64325e-07 18C-1.18645e-06 8.05887 8.05887 -3.62625e-07 18 -8.09946e-07C27.9411 -1.25727e-06 36 8.05887 36 18C36 27.9411 27.9411 36 18 36C8.05887 36 -3.422e-07 27.9411 -7.64325e-07 18ZM14.3454 26.1546C14.8726 26.6818 15.7274 26.6818 16.2546 26.1546L23.4546 18.9546C23.9818 18.4274 23.9818 17.5726 23.4546 17.0454L16.2546 9.8454C15.7274 9.3182 14.8726 9.3182 14.3454 9.8454C13.8182 10.3726 13.8182 11.2274 14.3454 11.7546L20.5908 18L14.3454 24.2454C13.8182 24.7726 13.8182 25.6274 14.3454 26.1546Z",
    fill: "white",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_756_5443"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHevronIrcle);
export default __webpack_public_path__ + "static/media/сhevron-сircle.720f5ab4268df37fc8a1798756ff767a.svg";
export { ForwardRef as ReactComponent };